import axios from "axios";
import * as Actions from "../actions/index"

const initialState = {
    //data
    isAuth: false,
    UserData: JSON.parse(sessionStorage.getItem("UserData")) || {},
    HistoryTab: null,
    isPilotOInstituations: 0,
    showVCL: 0,
    showVCH: 0,
    CountriesData: [],
    PatientsData: [],
    StatesData: [],
    PatientToEditData: null,
    Subscription: null,
    CardsDetail: [],
    InvoiceHistory: null,
    Bookings: [],
    VerifyData: null,

};

export const AuthReducer = (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case Actions.SET_IS_AUTH:
            return {
                ...state,
                isAuth: payload
            }
        case Actions.VERIFY_DATA:
            return {
                ...state,
                VerifyData: payload
            }
        case Actions.BOOKING_LIST:
            return {
                ...state,
                Bookings: payload,
            }
        case Actions.BILLING_DIALOG_DATA:
            return {
                ...state,
                [payload.key]: payload.value
            }
        case Actions.LOGIN_ATTEMPT:
            return {
                ...state,
                isAuth: true,
                UserData: payload,
            }

        case Actions.LOGOUT_ACTION:
            return {
                ...state,
                isAuth: false,
                // UserData: null
            }
        case Actions.HISTORY_DATA_GET:
            return {
                ...state,
                HistoryTab: payload
            }
        case Actions.SAVE_PERMISSIONS:
            return {
                ...state,
                ...payload
            }
        case Actions.DATA_FOR_ADD_PATIENTS:
            return {
                ...state,
                CountriesData: payload.Countries,
                PatientsData: payload.Patients

            }
        case Actions.GETTING_STATES:
            return {
                ...state,
                StatesData: payload
            }
        case Actions.EDIT_PATIENT:
            return {
                ...state,
                PatientToEditData: payload
            }

        case Actions.UPDATE_PHOTO:
            return {
                ...state,
                UserData: {
                    ...state.UserData,
                    photo: payload.photo
                }
            }
        case "CLEAN":
            return {
                isAuth: false,
                UserData: JSON.parse(sessionStorage.getItem("UserData")) || {},
                HistoryTab: null,
                isPilotOInstituations: 0,
                showVCL: 0,
                showVCH: 0,
                CountriesData: [],
                PatientsData: [],
                StatesData: [],
                PatientToEditData: null,
                Subscription: null,
                CardsDetail: [],
                InvoiceHistory: null,
                Bookings: [],
                VerifyData: null,
            }
        default:
            return state;
    }
}

